import {
    type AuditFilterChange,
    type AuditLogEntry,
    addAuditFilters,
    describeAuditAction,
    replaceAuditFilters,
    summarizeAuditEntry,
    useAuditText,
} from '@/domain/auditLog';

import CellFilterButton from './CellFilterButton';
import CellLines from './CellLines';
import RequestPill from './RequestPill';

import styles from './ActionCell.module.scss';

interface ActionCellProps {
    entry: AuditLogEntry;
    /** Loaded entries sharing this entry's request, or null when it is alone. */
    requestCount: number | null;
    onFilter: (change: AuditFilterChange) => void;
}

export default function ActionCell({ entry, requestCount, onFilter }: ActionCellProps) {
    const render = useAuditText();
    const action = describeAuditAction(entry.action);
    const summary = summarizeAuditEntry(entry);
    const line = summary.line === null ? null : render(summary.line);
    const title = summary.title.map(render).join('\n');
    const { requestId } = entry;

    return (
        <CellLines
            first={
                <>
                    <CellFilterButton
                        value={entry.action}
                        onFilter={() => onFilter(addAuditFilters(action.filter))}>
                        <span className={styles.area}>{action.area}</span>
                        <span className={styles.name}>{action.name}</span>
                    </CellFilterButton>
                    {requestCount === null || requestId === null ? null : (
                        <RequestPill
                            count={requestCount}
                            onShowRequest={() => onFilter(replaceAuditFilters({ requestId }))}
                        />
                    )}
                </>
            }
            firstTitle={entry.action}
            second={line}
            secondTitle={title === '' ? undefined : title}
        />
    );
}
